import { Api as API } from '../../config/apiCallDispatcher';
import { CreatePartnerReportCommentRequest, CreatePartnerReportCommentResponse } from './types';

export const createPartnerReportComment = async (reportId: number, payload: CreatePartnerReportCommentRequest) => {
    const response = await API.post('partners-write', `report/${reportId}/partner-comment`, payload);
    return response.data as CreatePartnerReportCommentResponse;
};
